import hintzehall from './assets/hintzehall.json';
import richardowen from './assets/richardowen.json';
import linnaeus from './assets/linnaeus.json';
import followers from './assets/1000.json';

export {hintzehall, richardowen, linnaeus, followers}